import { Button, Checkbox, Form, FormField, Grid, Input, Link, Modal, Select, Textarea, TokenGroup } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getAccountPlan, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import Favorites from '../../../../../components/extras/Favorites';
import SelectAccountPlan from '../../../../../components/selects/selectAccountPlans';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;

export const AdminProcessesInstallmentsPage = () => {
    type ItemIds = {
        label: string;
        dismissaLabel: string;
        idUser: number;
    }
    type User = {
        idUser: number;
        displayName: string;
        idUserStatus: number;
        status: string;
        RUT: string;
        phone1: string;
        email: string;
    };
    type ItemCharge = {
        ammount: number;
        accountPlan: string;
        idAccountPlan: number;
        data: string;
        obs: string;
        dateTransaction: string;

    }
    type ItemInstallments = {
        idMovementRecurring: number;
        amount: number;
        installments: number;
        accountPlan: string;
        idAccountPlan: number;
        currency: string;
        data: string;
        obs: string;
        idUsers: number[];
        day: number;

    }

    type ItemAccountPlan = {
        idAccountPlan: number;
        accountPlan: string;
        value: string;
        label: string;
    };
    const { data, menu, parameters } = useGlobalState();

    const [accountPlan, setAccountPlan] = useState<ItemAccountPlan>();
    const [accountPlans, setAccountPlans] = useState<ItemAccountPlan[]>([]);
    //const storeAdmin = useStoreAdmin();


    const [progress, setProgress] = useState(0);
    const [charge, setCharge] = useState<ItemCharge>({
        ammount: 0,
        accountPlan: '',
        idAccountPlan: 0,
        data: '',
        obs: '',
        dateTransaction: '',
    });

    const [installment, setInstallment] = useState<ItemInstallments>();


    const [sideOpen, setSideOpen] = useState(false);
    const [showModalInstallments, setShowModalInstallments] = useState(false);
    //const [installmentIsValid, setInstallmentIsValid] = useState(false);
    const [day, setDay] = useState(1);

    const [idCharges, setIdCharges] = useState<string>('');
    const [idInstallments, setIdInstallments] = useState<string>('');
    const [idUsersCharges, setIdUsersCharges] = useState<ItemIds[]>([]);
    const [idUsersInstallments, setIdUsersInstallments] = useState<ItemIds[]>([]);



    useEffect(() => {
        if (data) {
            const mappedAccountPlans: ItemAccountPlan[] = data.accountPlans.map((plan: ItemAccountPlan) => ({
                idAccountPlan: plan.idAccountPlan,
                accountPlan: plan.accountPlan,
                value: plan.idAccountPlan.toString(),
                label: plan.accountPlan
            }));
            setAccountPlans(mappedAccountPlans);
        }
    }, []);
    /*
    useEffect(() => {
        let isInvalid = false;
        if (!installment) isInvalid = true;
        if (installment.idAccountPlan === 0) isInvalid = true;
        if (idUsersInstallments.length === 0) isInvalid = true;
        if (installment.amount === 0) isInvalid = true;
        if (installment.data === "") isInvalid = true;
        setInstallmentIsValid(isInvalid)
    }, [installment]);
    */
    const installmentIsValid = !installment || installment.idAccountPlan === 0 || idUsersInstallments.length === 0 || installment.amount === 0 || installment.data === "";

    useEffect(() => {
        const result = idCharges.replace(".", "").toUpperCase().split(/[^0-9kK-]+/);
        const matchedItems: ItemIds[] = data.users
            .filter((user: { idUser: { toString: () => string; }; RUT: string; }) => result.includes(user.idUser.toString()) || result.includes(user.RUT))
            .map((user: { displayName: any; idUser: any; }) => ({
                label: user.displayName,
                idUser: user.idUser
            }));
        setIdUsersCharges(matchedItems)

    }, [idCharges]);
    useEffect(() => {
        const result = idInstallments.replace(".", "").toUpperCase().split(/[^0-9kK-]+/);
        const matchedItems: ItemIds[] = data.users
            .filter((user: { idUser: { toString: () => string; }; RUT: string; }) => result.includes(user.idUser.toString()) || result.includes(user.RUT))
            .map((user: { displayName: any; idUser: any; }) => ({
                label: user.displayName,
                idUser: user.idUser
            }));
        setIdUsersInstallments(matchedItems)

    }, [idInstallments]);


    const handleAddIntallments = async () => {
        try {
            setLoading(true)
            installment.idUsers = idUsersInstallments.map(u => u.idUser);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/installments/update',
                    'JWT': getCookie("JWT"),
                },

                body: JSON.stringify({
                    ...installment,
                    idMovementRecurring: 0
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setIdInstallments("")
                setInstallment(undefined);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }


    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => {
                setSideOpen(detail.open)
            }}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="m">

                        <Header
                            actions={<Favorites />}
                            description="Efectuar cargos en cuotas recurrentes a múltiples usuarios"
                        >Procesos de usuario</Header>


                        <Form actions={<Button variant='primary' disabled={idUsersInstallments.length === 0} onClick={() => {

                            setInstallment({
                                idMovementRecurring: 0,
                                amount: 0,
                                accountPlan: '',
                                idAccountPlan: 0,
                                data: '',
                                obs: '',
                                currency: '',
                                installments: 1,
                                idUsers: idUsersInstallments.map(u => u.idUser),
                                day: 1,
                            })
                        }}
                        >Siguiente</Button>} >

                            <SpaceBetween direction="vertical" size="xs">

                                <FormField
                                    constraintText={"Al pegar los nuevos elementos se generará un listado de usuarios seleccionados"}
                                    label={'Identificación de usuarios'}
                                    info={idUsersInstallments.length === 0 ? null : <Link onClick={() => setIdInstallments("")}>Limpiar</Link>}
                                >
                                    <Textarea
                                        onChange={({ detail }) => {
                                            setIdInstallments(detail.value.replace(".", "").toUpperCase().split(/[^0-9kK-]+/).join(" "));
                                        }}
                                        value={idInstallments}
                                        placeholder="Pegar RUTs o ID de usuarios"
                                    />

                                </FormField>
                                <TokenGroup
                                    readOnly
                                    onDismiss={({ detail: { itemIndex } }) => {
                                        return;

                                    }}
                                    items={idUsersInstallments}
                                    limit={3}
                                />
                            </SpaceBetween>
                        </Form>



                    </SpaceBetween>
                    {!!installment && (
                        <Modal visible={!!installment} header={
                            <span>
                                Detalle de cargo en cuotas:
                            </span>
                        } size="medium" footer={<Box textAlign='right'>
                            <Button
                                disabled={installmentIsValid}
                                onClick={() => handleAddIntallments()}
                                variant='primary'>Generar</Button>
                        </Box>
                        } onDismiss={() => setInstallment(undefined)}>
                            <Grid gridDefinition={[{ colspan: 4 }, { colspan: 2 }, { colspan: 3 }, { colspan: 3 }]}>
                                <div>
                                    <FormField label={"Destinatarios"}>
                                        <Input readOnly value={`${idUsersInstallments.length} usuario${idUsersInstallments.length > 1 ? "s" : ""}`} />
                                    </FormField>
                                </div>
                                <div>
                                    <FormField label={"Día ejec."}>
                                        <Input type="number" value={day.toString()} onChange={(event) => {
                                            let value = Number(event.detail.value);
                                            if (isNaN(value)) {
                                                setDay(Number(1))
                                                setInstallment({ ...installment, day: 1 });
                                            } else if (value <= 0) {
                                                setDay(Number(1))
                                                setInstallment({ ...installment, day: 1 });
                                            } else if (value > 28) {
                                                setDay(Number(28))
                                                setInstallment({ ...installment, day: 28 });
                                            } else {
                                                setDay(Number(event.detail.value))
                                                setInstallment({ ...installment, day: Number(event.detail.value) });
                                            }
                                        }} />
                                    </FormField>
                                </div>

                                <div>
                                    <FormField label={"Cuotas"} constraintText={<>
                                        <Checkbox checked={installment?.installments === 0} onChange={({ detail }) => {
                                            if (!installment) return;
                                            if (detail.checked)
                                                setInstallment({ ...installment, installments: 0 });
                                            else
                                                setInstallment({ ...installment, installments: 1 });
                                        }}>Sin término</Checkbox>
                                    </>}>
                                        <Input type='number' value={installment?.installments.toString() || "0"}
                                            onChange={({ detail }) => {
                                                if (!installment) return;
                                                setInstallment({ ...installment, installments: Number(detail.value) });
                                            }} />
                                    </FormField>
                                </div>

                                <div>
                                    <FormField label={"Moneda"}>
                                        <Select
                                            selectedOption={{ value: installment.currency, label: installment.currency }}
                                            onChange={({ detail }) => {
                                                const selected = detail.selectedOption;
                                                // Update charge
                                                setInstallment({
                                                    ...installment,
                                                    currency: selected.value ?? "",
                                                    amount: 0
                                                });

                                            }}
                                            options={[
                                                { value: "", label: "Seleccione" },
                                                { value: "CLP", label: "CLP" },
                                                { value: "UF", label: "UF" },
                                                { value: "USD", label: "USD" },
                                            ]}
                                        />

                                    </FormField>
                                </div>
                            </Grid>
                            {installment.currency !== "" && (<>
                                <Grid gridDefinition={[{ colspan: 6 }, { colspan: 6 }]}>
                                    <div>
                                        <FormField label={"Monto"}>
                                            <Input type='number'
                                                step={installment.currency === "CLP" ? 1 :
                                                    installment.currency === "UF" ? 0.00001 :
                                                        0.01}
                                                onKeyDown={(e) => {
                                                    if (installment.currency === "CLP" && e.detail.key === ".") {
                                                        e.preventDefault(); // block decimal point
                                                    }
                                                }}
                                                value={installment?.amount.toString() || "0"}
                                                onChange={({ detail }) => {
                                                    if (!installment) return;

                                                    let decimals = 0;
                                                    if (installment.currency === "UF") decimals = 5;
                                                    else if (installment.currency === "USD") decimals = 2;

                                                    let numeric = Number(detail.value || "0");
                                                    if (!isNaN(numeric)) {
                                                        numeric = Number(numeric.toFixed(decimals));
                                                    }

                                                    setInstallment({
                                                        ...installment,
                                                        amount: numeric,
                                                    });
                                                }}

                                            />
                                        </FormField>
                                    </div>
                                    <div>
                                        <FormField label={"Cuenta"}>
                                            <SelectAccountPlan single value={accountPlan?.idAccountPlan ?? 0} onSelect={(idAccountPlan: any) => {

                                                setInstallment({
                                                    ...installment,
                                                    idAccountPlan: idAccountPlan,
                                                    accountPlan: getAccountPlan(idAccountPlan, data).accountPlan
                                                });
                                            }} />
                                        </FormField>
                                    </div>
                                </Grid>
                                <Grid gridDefinition={[{ colspan: 12 }]}>
                                    <div>
                                        <FormField label={"Concepto"}>
                                            <Input value={installment?.data.toString() || ""}
                                                onChange={({ detail }) => {
                                                    if (!installment) return;
                                                    setInstallment({ ...installment, data: detail.value });
                                                }} />
                                        </FormField>
                                    </div>
                                </Grid>
                            </>
                            )}
                        </Modal>
                    )}




                </>
            }
        />
    );
};
